import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-base md:text-lg text-brown text-left font-semibold border-separate border-spacing-x-4" }

import { PersonalBaziIndicators } from "@/types/calculators";

import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalIndicators',
  props: {
    personalIndicators: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.bazi.results.personal-indicators.personal-element")), 1),
          _createElementVNode("td", null, _toDisplayString(__props.personalIndicators.personal_element), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.bazi.results.personal-indicators.gua-number")), 1),
          _createElementVNode("td", null, _toDisplayString(__props.personalIndicators.gua_number), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.bazi.results.personal-indicators.nobleman")), 1),
          _createElementVNode("td", null, _toDisplayString(__props.personalIndicators.nobleman), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.bazi.results.personal-indicators.void")), 1),
          _createElementVNode("td", null, _toDisplayString(__props.personalIndicators.void), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.bazi.results.personal-indicators.peach")), 1),
          _createElementVNode("td", null, _toDisplayString(__props.personalIndicators.peach), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.bazi.results.personal-indicators.horse")), 1),
          _createElementVNode("td", null, _toDisplayString(__props.personalIndicators.horse), 1)
        ])
      ])
    ])
  ]))
}
}

})